module.exports = __webpack_public_path__ + "img/payment-card-50.7ca11df5.svg";